import { Market } from '@org-avp/models';
import { Locale } from '@org-avp/avp-hck-dga-customerui-commons';
import { MarketWebsites } from '../marketUtils';

export const vwMarketSites: Partial<Record<Market, Array<MarketWebsites>>> = {
  [Market.DEU]: [
    {
      locale: Locale.de_DE,
      configurator: 'https://www.volkswagen.de/de/konfigurator.html',
      testdrive: 'https://www.volkswagen.de/de/formulare/probefahrtanfrage.html',
    },
  ],
  [Market.IRL]: [
    {
      locale: Locale.en_IE,
      configurator: 'https://www.volkswagen.ie/en/build.html',
      testdrive: 'https://www.volkswagen.ie/en/forms/testdrive.html',
    },
  ],
  [Market.ITA]: [
    {
      locale: Locale.it_IT,
      configurator: 'https://www.volkswagen.it/it/configuratore.html',
      testdrive: 'https://www.volkswagen.it/it/forms/test-drive.html',
    },
  ],
  [Market.ESP]: [
    {
      locale: Locale.es_ES,
      configurator: 'https://www.volkswagen.es/es/configurador.html',
      testdrive: 'https://formulario.volkswagen.es/test-drive',
    },
  ],
  [Market.CHE]: [
    {
      locale: Locale.de_CH,
      configurator: 'https://www.volkswagen.ch/de/konfigurator.html',
      testdrive: 'https://www.volkswagen.ch/de/formulare/probefahrtanfrage.html',
    },
    {
      locale: Locale.it_CH,
      configurator: 'https://www.volkswagen.ch/it/configuratore.html',
      testdrive: 'https://www.volkswagen.ch/it/moduli/prova-di-guida.html',
    },
    {
      locale: Locale.fr_CH,
      configurator: 'https://www.volkswagen.ch/fr/configurateur.html',
      testdrive: 'https://www.volkswagen.ch/fr/formulaires/essai-routier.html',
    },
  ],
  [Market.POL]: [
    {
      locale: Locale.pl_PL,
      configurator: 'https://www.volkswagen.pl/pl/konfigurator.html',
      testdrive: 'https://www.volkswagen.pl/pl/formularze/jazda-probna.html',
    },
  ],
  [Market.SWE]: [
    {
      locale: Locale.sv_SE,
      configurator: 'https://www.volkswagen.se/sv/bygg-din-bil.html',
      testdrive: 'https://www.volkswagen.se/sv/forms/provkorning.html',
    },
  ],
  [Market.FRA]: [
    {
      locale: Locale.fr_FR,
      configurator: 'https://www.volkswagen.fr/fr/configurateur.html',
      testdrive: 'https://www.volkswagen.fr/fr/formulaires/essai-routier.html',
    },
  ],
  [Market.GBR]: [
    {
      locale: Locale.en_GB,
      configurator: 'https://www.volkswagen.co.uk/en/configurator.html',
      testdrive: 'https://www.volkswagen.co.uk/en/forms/testdrive.html',
    },
  ],
  [Market.NOR]: [
    {
      locale: Locale.no_NO,
      configurator: 'https://www.volkswagen.no/no/bygg-din-volkswagen.html',
      testdrive: 'https://www.volkswagen.no/no/skjemaer/provekjore.html',
    },
  ],
  [Market.LUX]: [
    {
      locale: Locale.fr_LU,
      configurator: 'https://www.volkswagen.lu/fr/configurateur.html',
      testdrive: 'https://www.volkswagen.lu/fr/formulaires/essai-routier.html',
    },
  ],
  [Market.AUT]: [
    {
      locale: Locale.de_AT,
      configurator: 'https://konfigurator.volkswagen.at/cc-at/de_AT_VW22/V/models',
      testdrive: 'https://www.volkswagen.at/probefahrt',
    },
  ],
  [Market.NZL]: [
    {
      locale: Locale.en_NZ,
      testdrive: 'https://www.volkswagen.co.nz/app/nz/test-drive',
    },
  ],
  [Market.NLD]: [
    {
      locale: Locale.nl_NL,
      configurator: 'https://www.volkswagen.nl/nl/configurator.html',
      testdrive: 'https://www.volkswagen.nl/nl/formulieren/proefrit.html',
    },
  ],
  [Market.ZAF]: [
    {
      locale: Locale.en_ZA,
      configurator: 'https://www.vw.co.za/en/configurator.html',
      testdrive: 'https://www.vw.co.za/en/forms/testdrive.html',
    },
  ],
};
